// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const FIREBASE_STATE_CHANGED = 'FIREBASE_STATE_CHANGED';
export const SETQRIMAGE = 'SETQRIMAGE';
export const REQUIRESETPASSWORD = 'REQUIRESETPASSWORD';
export const SESSION_TIMEOUT = 'SESSION_TIMEOUT';
